// extracted by mini-css-extract-plugin
module.exports = {"delivery":"DeliveryPayment_delivery__3qSHr","payment":"DeliveryPayment_payment__3ce0o","rightImg":"DeliveryPayment_rightImg__1-H7g"};